import NiceModal, { useModal } from '@ebay/nice-modal-react';
import clickOutside from '/src/hooks/useClickOutside';
import './EditorWindow.css';
import { useRef, useEffect } from 'react';
import { disableWillChange } from '../../utils/performanceEditor';
import { useChatboxDispatchContext } from '../../../chatbox/context/ChatboxContext'

// Component for displaying a side popup on the left
function EditorWindow({ Component, componentProps, id }) {

    //const Conponent = ListComponentsEditable[type];

    const modal = useModal();
    const editorRef = useRef("editor");

    const dispatch = useChatboxDispatchContext();

    // If we click outside the popup that will close but not if it's a block or the variable_manager
    // Like this we can keep the component up and changing the form without a rerun of the animation
    clickOutside(editorRef, (event) => {
        
        // Messy fix if we don't want to close this window when we open a 'popup' component
        if(document.getElementsByClassName('popup').item(0)) {
            return false;
        }

        const chatbox = document.getElementsByClassName('kwalys-chatbox-window').item(0);
        if(chatbox && chatbox.contains(event.target)) {
            return;
        }

        const element = document.getElementById(componentProps.id);
        if(element) {
            element.classList.remove('selected')
        }
        
        editorRef.current.classList.add('closing');
        // Remove after 350 for letting the animation put thank's to the className 'closing'
        setTimeout(() => {
            modal.remove()
        }, 350);
        dispatch({ type : 'toggleMargin'})
    }, ['block', 'variable_manager', 'play', 'restart', 'run'])

    // Fix performance for blocks when we click on the modal, they can have a 'blur' effect if this line is omit
    disableWillChange();

    useEffect(() => {
        dispatch({ type : 'toggleMargin'})
    }, [])

    return (
        <div className='editor-window' ref={editorRef}>
            <div className='interface'>
                <Component {...componentProps} key={componentProps.id}/>
            </div>
        </div>
    )
}
EditorWindow.defaultProps = {
    componentProps : {}
}
export default NiceModal.create(EditorWindow);